module.exports = __webpack_public_path__ + "img/63.8c5f9742.jpg";